<template>
  <v-container grid-list-lg px-5 >
    <ImageGallery :images="orderedImages" />
  </v-container>
</template>

<script>
import { db } from '@/firebase/db';
import ImageGallery from '@/components/galleries/image/index.vue';

export default {
  components: { ImageGallery },
  mounted() {
    this.$bind('atlas', db.collection('atlas').doc(this.$route.params.atlasID));
    this.$bind(
      'images',
      db
        .collection('atlas')
        .doc(this.$route.params.atlasID)
        .collection('files'),
    );
  },

  watch: {
    atlas: {
      handler(newAtlas) {
        console.log(newAtlas);
        this.$store.state.currentAtlas = newAtlas.name;
      },
    },
  },
  data: () => ({
    images: [],
    atlas: null,
  }),
  computed: {
    orderedImages() {
      const newArray = this.images.slice();
      return newArray.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'en', { sensitivity: 'base', numeric: true }));
    },
  },
};
</script>
